import * as Constants from './mutation-types';
import {
    cartUpdater,
    syncQuantity,
    updateTicketState,
    addUnitPriceToProduct,
    addUnitPrice, buildKey
} from "../helpers/productHelper";

const syncProductQuantityBetweenCartAndProduct = (products, cart) => {
    if (!products.length) return [];

    products.forEach(product => {
        const cartProduct = cart.find(pr => pr.product_id === product.product_id);
        if (cartProduct) product.quantity = cartProduct.quantity;
        return product;
    })
};

export const productMutations = {
    [Constants.ADD_FLEX_TICKETS](state, payload) {
        state.flexTickets = addUnitPriceToProduct(payload.tickets);
    },

    [Constants.ADD_TODAY_PRODUCTS](state, payload) {
        state.todayProducts = addUnitPrice(payload.products);
    },

    [Constants.REMOVE_FLEX_TICKETS](state) {
        state.flexTickets = [];
    },

    [Constants.SET_CURRENT_TICKET](state, {ticket}) {
        state.ticket = ticket;
    },

    [Constants.SET_WEEKDAYS_ONLY](state, {weekdaysOnly}) {
        state.weekdaysOnly = weekdaysOnly;
    }
};

export const cartMutations = {
    [Constants.RESTORE_CART_PRODUCTS](state, {products}) {
        state.cart = products;

        // Since today and promotions products come from server side,
        // cart quantity needs to be synchronize between products.
        syncProductQuantityBetweenCartAndProduct(state.todayProducts, state.cart);
        syncProductQuantityBetweenCartAndProduct(state.promotionsProducts, state.cart);
    },

    [Constants.ADD_PRODUCTS_TO_CART](state, payload) {
        const {action, product, ticket, updateFrom} = payload;
        const {increment = 1, min_cart = 0, max_cart = 10} = product;
        if (action === 'decrease' && product.quantity > min_cart) {
            product.quantity -= increment;
        }

        if (action === 'increase' && product.quantity < max_cart) {
            product.quantity += increment;
        }
        if(product.grouped_price){
            product.price = product.grouped_price * product.quantity;
        }
        const productIndex = state.cart.findIndex(p => p.key ? p.key === product.key : p.product_id === product.product_id);
        syncQuantity({product, cart: state.cart, currentTicket: state.ticket, updateFrom, events: state.events, selectedFixEvent: state.selectedFixEvent});

        // Add to the cart if the ticket not exists
        if (!~productIndex) {

            state.cart.push(product);
        }
        else{
            const productIndex = state.cart.findIndex(pr => pr.key === product.key)
            state.cart[productIndex] = product
        }
        updateTicketState(state, ticket);
    },

    /**
     * Remove a product from cart
     *
     * @param state
     * @param payload
     */
    [Constants.REMOVE_PRODUCT_TO_CART](state, payload) {
        const {product, dispatch} = payload;
        product.quantity = 0;
        cartUpdater(state.cart, dispatch);
        syncQuantity({product, cart: state.cart, currentTicket: state.ticket, updateFrom: 'cart'});
        updateTicketState(state);
    },

    /**
     * Merge ids from remote cart into local cart
     *
     * @param state
     * @param remoteCart
     */
    [Constants.MERGE_LOCAL_AND_REMOTE_CART](state, {remoteCart}) {
        // Remove items with quantity 0
        state.cart = state.cart.filter(p => !!p.quantity);
        state.cart.forEach(p => {
            const product = remoteCart.products.find(remoteProduct => {
                if (remoteProduct.pur_type === 'FIX') {
                    return buildKey(remoteProduct).key === p.key;
                }
                return p.product_id === remoteProduct.product_id;
            });
            if (product) {
                p.id = product.id;
                p.price = product.price;
                p.title = product.title;
            }
        });
    }
};

export const footerMutations = {
    [Constants.TOGGLE_FOOTER](state) {
        state.show = !state.show;
    }
};

export const passesMutations = {
    [Constants.PASSES_CART](state, cart) {
        state.passescart = cart;
    }
};

export const flexMutations = {
    [Constants.TOGGLE_WEEKDAY_SWITCH](state) {
        state.weekdaysOnly = !state.weekdaysOnly;
    }
};

export const fixMutations = {
    [Constants.SET_DAYS_QUANTITY](state, {daysQuantity}) {
        state.daysQuantity = daysQuantity;
    },

    [Constants.SET_FIX_TICKETS](state, payload) {
        state.events = payload.fixTickets;
    },

    [Constants.REMOVE_FIX_TICKETS](state) {
        state.events = {};
        state.selectedFixEvent = {}
    },

    [Constants.SET_SELECTED_FIX_EVENT](state, {day}) {
        const event = state.events[day];
        const cartProducts = state.cart;
        if (event.ticket) {
            event.ticket.products = event.ticket.products.map(product => {
                const p = cartProducts.find(
                    pr => pr.start_date === product.start_date && pr.product_id === product.product_id
                );
                if (p) product.quantity = p.quantity;
                return product;
            });
    
            state.selectedFixEvent = event;
        }

    },

    [Constants.REMOVE_SELECTED_FIX_EVENT](state) {
        state.selectedFixEvent = {};
    },

    [Constants.SELECT_DEFAULT_FIX_TICKET](state) {
        if (Object.keys(state.events).length) {
            state.selectedFixEvent = state.events[state.fixTicketDefaultDate];
        }
    },

    [Constants.SET_LOADING_STATUS](state, {status}) {
        state.loading = status;
    }
};

export const stockDateMutations = {
    [Constants.SET_STOCK_DATES](state, stockDate){
        state.stockDate = stockDate;
    }
};


// WEBPACK FOOTER //
// ./src/store/mutations.js